// extracted by mini-css-extract-plugin
module.exports = {"tinyWidgets":"TinyWidgets_tinyWidgets__lCX2F","container":"TinyWidgets_container__l_4P7","collapseButton":"TinyWidgets_collapseButton__3MrfP"};